import { ResolveFn } from '@angular/router'
import { inject } from '@angular/core'
import { catchError } from 'rxjs/operators'
import { of } from 'rxjs'
import { GlobalSettingsService } from '../../api/services'

export const preferencesResolver: ResolveFn<any> = (route, state) => {
    const authService = inject(GlobalSettingsService)
    return authService.globalSettingsGetGlobalSettings().pipe(
        catchError((err) => {
            return of(err)
        }),
    )
}
